import axios from 'axios'
import { useContext, useState, useEffect } from 'react'
import urlSearchParams from '../../components/urlSearchParams'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, success, getNewToken } from '../../shared/constants'

export const useCheckinCheckout = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const [attendance, setAttendance] = useState(false)
  const [log, setLog] = useState([])
  const [paginateData, setPaginateData] = useState()
  const [loading, setLoading] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [pdfCsvData, setPdfCsvData] = useState({ headings: [], headingValues: [] })
  const [cancelToken, setCancelToken] = useState()

  const { getNewEmployeeAttendances } = useContext(ConfigurationContext)

  const downloadKeys = {
    ATTENDANCE: 'ATTENDANCE',
  }

  const downloadAPI = (key) => {
    switch (key) {
      case downloadKeys.ATTENDANCE:
        return API.GET_BELOW_EMPLOYEE_ATTENDANCE
      default:
        return ''
    }
  }

  const getCheckInCheckOutReport = async (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_CHECKIN_CHECKOUT_REPORT(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        } else{
            setPaginateData(data.paginate)
            setLog(data.data)
        }
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getPdfCsvData = async (url, dto = {}) => {
    console.log('ji1')
    setDownloadLoading(true)
    dto = { ...dto, download: 1 }
    console.log('ji1', dto, url)
    axios
      .get(API[url](urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setDownloadLoading(false)
        if (status !== 200) {
          console.log('ji1')
          return toastMessage('Something Went Wrong !', error)
        }
        setPdfCsvData(data)
      })
      .catch((err) => {
        setDownloadLoading(false)
        if (err.response) {
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  return {
    getCheckInCheckOutReport,
    attendance,
    log,
    getPdfCsvData,
    pdfCsvData,
    downloadKeys,
    downloadLoading,
    paginateData,
  }
}
